// Generated schema defaults retain their original object and serialized shape.
// Only identity-tagged system maps opt in; arbitrary caller messages stay data.
const generatedDefaults = new WeakMap()
export function markAdminValidationMessages(messages, options) {
  generatedDefaults.set(messages, options || {})

  return messages
}
export function adminValidationSource(messages) {
  return messages && generatedDefaults.get(messages)
}
